
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_PulseAnimation";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_PulseAnimation__root"};
export var keyframes = {"pulseSmallB10":"wds_1_130_0_PulseAnimation__pulseSmallB10","pulseMediumB10":"wds_1_130_0_PulseAnimation__pulseMediumB10","pulseSmallR10":"wds_1_130_0_PulseAnimation__pulseSmallR10","pulseMediumR10":"wds_1_130_0_PulseAnimation__pulseMediumR10","pulseSmallP10":"wds_1_130_0_PulseAnimation__pulseSmallP10","pulseMediumP10":"wds_1_130_0_PulseAnimation__pulseMediumP10","pulseSmallG10":"wds_1_130_0_PulseAnimation__pulseSmallG10","pulseMediumG10":"wds_1_130_0_PulseAnimation__pulseMediumG10"}; 
export var layers = {};
export var containers = {};
export var stVars = {"animationDuration":"1050ms","smallShadowSpread":"30px","mediumShadowSpread":"12px"}; 
export var vars = {}; 




